import StoreShoppingOptions from 'components/ShopYourStore/StoreShoppingOptions/StoreShoppingOptions';

export default StoreShoppingOptions;
